// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-wrap[data-v-307772ba]{width:100%}.form-wrap .form-item[data-v-307772ba]{margin-bottom:24px}.form-wrap .form-item[data-v-307772ba]:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
